/**
 * BESLUIT FRANK 23 OKTOBER 2026: in het menu staat Chats bovenaan en daarna alles op
 * alfabetische volgorde IN DE GEKOZEN TAAL, en de projecten in het blok Projecten ook.
 *
 * Daarom sorteert dit op het LABEL zoals de persoon het leest, en niet op een sleutel:
 * "Geheugen" staat in het Nederlands voor "Kennis", "Memory" in het Engels na
 * "Knowledge". Een vaste lijst in de code zou in een van de twee talen fout staan.
 * De vergelijking is hoofdletterongevoelig, want "PRACTIQ" hoort bij de P van
 * "Plexaris" en niet ervoor omdat een hoofdletter in ASCII eerder komt.
 */
export function opVolgorde(items, taal, label = (i) => i.label) {
  const vergelijk = new Intl.Collator(taal, { sensitivity: "base", numeric: true }).compare;
  return [...(items || [])].sort((a, b) => vergelijk(label(a), label(b)));
}
